import { inject, Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';
import { ToastController } from '@ionic/angular';

import { StaffNotification } from '@models/index';

import { INotificationService } from './inotification.service';
import { NotificationBaseService } from './notification-base.service';

@Injectable({
    providedIn: 'root'
})
export class NotificationToastService extends NotificationBaseService implements INotificationService {
    private readonly toastController = inject(ToastController);

    private notificationSubject = new Subject<StaffNotification>();

    get(): Observable<StaffNotification> {
        return this.notificationSubject.asObservable();
    }

    sendNotification(notification: StaffNotification): void {
        this.notificationSubject.next(notification);
    }

    async add(notification: Partial<StaffNotification>): Promise<void> {
        const toast = await this.toastController.create({
            message: notification.description,
            duration: 3000,
            position: 'top',
            cssClass: notification.class,
            icon: notification.icon
        });

        await toast.present();
    }
}
